"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContentInstanceByItem = exports.startOfPeriod = exports.shiftOfPeriod = void 0;
var date_fns_1 = require("date-fns");
var __1 = require("..");
var enums_1 = require("../../enums");
var content_1 = require("../content");
var enums_2 = require("../enums");
function shiftOfPeriod(period, endAt) {
  if (endAt === void 0) {
    endAt = new Date();
  }
  switch (period) {
    case enums_1.EPopularityPeriod.day:
      return (0, date_fns_1.addDays)(endAt, -1);
    case enums_1.EPopularityPeriod.week:
      return (0, date_fns_1.addWeeks)(endAt, -1);
    case enums_1.EPopularityPeriod.month:
      return (0, date_fns_1.addMonths)(endAt, -1);
    case enums_1.EPopularityPeriod.year:
      return (0, date_fns_1.addYears)(endAt, -1);
  }
}
exports.shiftOfPeriod = shiftOfPeriod;
function startOfPeriod(period, endAt) {
  if (endAt === void 0) {
    endAt = new Date();
  }
  switch (period) {
    case enums_1.EPopularityPeriod.day:
      return (0, date_fns_1.startOfDay)(endAt);
    case enums_1.EPopularityPeriod.week:
      return (0, date_fns_1.startOfWeek)(endAt);
    case enums_1.EPopularityPeriod.month:
      return (0, date_fns_1.startOfMonth)(endAt);
    case enums_1.EPopularityPeriod.year:
      return (0, date_fns_1.startOfYear)(endAt);
  }
}
exports.startOfPeriod = startOfPeriod;
function getContentInstanceByItem(item) {
  switch (item.type) {
    case enums_2.ContentTypeEnum.video:
      return new __1.Video(item);
    case enums_2.ContentTypeEnum.audio:
      return new __1.Audio(item);
    case enums_2.ContentTypeEnum.image:
      return new __1.Image(item);
    case enums_2.ContentTypeEnum.vocabulary:
      return new __1.Vocabulary(item);
    case enums_2.ContentTypeEnum.microtext:
      return new __1.MicroText(item);
    case enums_2.ContentTypeEnum.article:
    case enums_2.ContentTypeEnum.news:
      return new __1.Text(item);
    default:
      if (enums_2.LessonContentType.includes(item.type)) {
        return new __1.Lesson(item);
      }
      // General Content (used in constructor, before item.type is defined)
      return new content_1.Content(item);
  }
}
exports.getContentInstanceByItem = getContentInstanceByItem;
